import { useResearchDrawer } from "./ResearchDrawerContext";
import { ScienceRounded as ResearchIcon } from "@mui/icons-material";
import { Badge, IconButton, Tooltip } from "@mui/material";
import { useParams } from "react-router-dom";
import * as researchService from "services/researchService";

// Self-contained badge: takes a fieldKey, fetches the current session, and
// renders a small clickable indicator next to a form field showing how many
// research items have been cited into that field.
//
// Renders nothing when there are no citations or no submission context, so
// it's safe to drop in next to any input regardless of state.
const ResearchCitationBadge = ({ fieldKey }) => {
  const { submissionId } = useParams();
  const { openDrawer, isAvailable } = useResearchDrawer();

  const { data: session } = researchService.useGetSessionQuery(
    { submissionId },
    { skip: !submissionId }
  );

  const items = session?.items || [];
  const citationCount = items.reduce((count, item) => {
    if (item.isCited && (item.citedIn || []).includes(fieldKey)) {
      return count + 1;
    }
    const citedSources = (item.sources || []).filter(
      (source) => source.cited && (source.citedIn || []).includes(fieldKey)
    );
    return count + citedSources.length;
  }, 0);

  if (citationCount === 0) return null;

  return (
    <Tooltip
      title={`${citationCount} research item${
        citationCount !== 1 ? "s" : ""
      } cited here — click to open research drawer`}
      enterDelay={500}
    >
      <IconButton
        size={"small"}
        onClick={isAvailable ? openDrawer : undefined}
        sx={{ p: 0.25 }}
      >
        <Badge badgeContent={citationCount} color={"primary"} max={99}>
          <ResearchIcon fontSize={"small"} color={"action"} />
        </Badge>
      </IconButton>
    </Tooltip>
  );
};

export default ResearchCitationBadge;
